export default {
    methods: {
        createVuexSubscription(name, func) {
            return this.$store.subscribe((mutation, state) => {
                if (mutation.type === name) {
                    func.call(null, mutation.payload, state);
                }
            });
        },
    },
};
